module.exports = __webpack_public_path__ + "img/mail-forward.611d960d.svg";